import { Path } from '@/types/global';
import { RequestMVRFormFields } from './types';

export const path = (path: Path<RequestMVRFormFields>) => path;
